import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

// ChartContainer: wraps chart, provides config for legend/colors
export function ChartContainer({ config, className, children, style }) {
  return (
    <Box className={className} style={style} sx={{ width: '100%', maxWidth: '100%', overflow: 'visible', p: { xs: 1, sm: 2 } }}>
      {children}
    </Box>
  );
}
ChartContainer.propTypes = {
  config: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
};

// ChartLegend: renders a color-coded legend based on config
export function ChartLegend({ config, className }) {
  if (!config) return null;
  return (
    <Box className={className} sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, rowGap: 0.5, mt: 2 }}>
      {Object.entries(config).map(([key, { label, color }]) => (
        <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 16, height: 16, borderRadius: '4px', backgroundColor: color, mr: 0.5, border: '1px solid #ccc' }} />
          <Typography variant="body2" sx={{ color: '#fff', fontSize: { xs: '0.83rem', sm: '0.95rem' } }}>{label}</Typography>
        </Box>
      ))}
    </Box>
  );
}
ChartLegend.propTypes = {
  config: PropTypes.object.isRequired,
  className: PropTypes.string,
};

// ChartLegendContent: alias for ChartLegend (for API symmetry with shadcn)
export const ChartLegendContent = ChartLegend;

// ChartTooltip: wraps recharts Tooltip or provides custom tooltip logic
export function ChartTooltip({ content }) {
  return content || null;
}
ChartTooltip.propTypes = {
  content: PropTypes.node,
};

// ChartTooltipContent: simple default tooltip
export function ChartTooltipContent({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <Box sx={{ background: '#222', color: '#fff', p: 1, borderRadius: 1, fontSize: '0.93rem', minWidth: 80 }}>
        <Typography variant="caption" sx={{ color: '#bbb' }}>{label}</Typography>
        {payload.map((entry, idx) => (
          <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end', textAlign: 'right' }}>
            <Box sx={{ width: 10, height: 10, borderRadius: '2px', backgroundColor: entry.color, mr: 1 }} />
            <span>{entry.name}: <b>&#8377;{entry.value}</b></span>
          </Box>
        ))}
        <Box sx={{ borderTop: '1px solid #444', mt: 1, pt: 1, textAlign: 'right' }}>
          <b>Total: &#8377;{payload.reduce((sum, entry) => sum + (Number(entry.value) || 0), 0)}</b>
        </Box>
      </Box>
    );
  }
  return null;
}
ChartTooltipContent.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.any,
};
